import React, { useState, useRef } from "react";
import ReactDOM from "react-dom";

const Tooltip = ({ children, content }) => {
  const [visible, setVisible] = useState(false);
  const targetRef = useRef(null);
  const [position, setPosition] = useState({ left: 0, top: 0 });

  // Update position on mouse enter
  const showTooltip = () => {
    if (targetRef.current) {
      const rect = targetRef.current.getBoundingClientRect();
      // Adjust the tooltip to appear above the element
      setPosition({
        left: rect.left + rect.width / 2,
        top: rect.top - 8, // adjust as needed
      });
    }
    setVisible(true);
  };

  const hideTooltip = () => {
    setVisible(false);
  };

  // The tooltip element rendered in a portal
  const tooltipElement = visible ? (
    <div
      style={{
        position: "fixed",
        left: position.left,
        top: position.top,
        transform: "translate(-50%, -100%)",
        backgroundColor: "var(--tertiary)",
        color: "#fff",
        padding: "8px",
        borderRadius: "4px",
        fontSize: "14px",
        zIndex: 9999,
        whiteSpace: "normal",
        maxWidth: "200px",
      }}
    >
      {content}
    </div>
  ) : null;

  return (
    <span className="tooltip">
      <span
        ref={targetRef}
        onMouseEnter={showTooltip}
        onMouseLeave={hideTooltip}
        style={{ cursor: "help" }}
      >
        {children}
      </span>
      {ReactDOM.createPortal(tooltipElement, document.body)}
    </span>
  );
};

export default Tooltip;
